<template>
  <div class="grid">
    <div class="col-12 dashboard">
      <div class="card">
        <h1>{{ $t("reclamacion.tituloListado") }}</h1>
        <ListaReclamacionesDetalle
          :myClaims="true"
          :idLegalCliente="idLegalCliente"
          :idLegalUsuario="idLegalUsuario"
        />
      </div>
    </div>
  </div>
</template>


<script>
import ListaReclamacionesDetalle from "./ListaReclamacionesDetalle.vue";
export default {
  props: ["idLegalCliente", "idLegalUsuario"],
  components: {
    ListaReclamacionesDetalle: ListaReclamacionesDetalle,
  },
  data() {
    return {};
  },
};
</script>


<style lang="scss" scoped>
</style>